<div [id]="id" class="content">
  <app-breadcrumb [items]="breadcrumbs"></app-breadcrumb>
  <h2>Instellingen</h2>
  <div class="card-button-container">
    @for (button of buttonSettings; track button; let i = $index) {
      <app-card-button
        class="card-button"
        [number]="i+1"
        [buttonSettings]="button"
        (click)="onClick(button)"
      ></app-card-button>
    }
  </div>
</div>
